<div *ngIf="IsLoading" class="loader_cls">
  <div class="app-loader"></div>
</div>
<div class="policyquotescls">
  <div *ngIf="!isFromManagePolicy" class="row">
    <div class="col-md-6">
      <h4 class="heading_search_policies">Evidence of Insurance</h4>
    </div>
    <div class="col-md-6">
      <button style="float:right;margin-left: 15px;" name="DocumentBtn" id="DocumentBtnID"
          class="btn btn-small btn_create_policy_quotes mt-1" (click)="clickDocument()">
          <i name="DocumentBtnIcon" id="DocumentBtnIconID" class="fa fa-file"></i> &nbsp;
          Document Center
      </button>
      <button style="float:right" name="OnlineQuoteBtn" id="OnlineQuoteBtnID"
        class="btn btn-small btn_create_policy_quotes mt-1" (click)="CreateOnlineQuote()">
        <i name="OnlineQuoteIcon" id="OnlineQuoteIconID" class="fa fa-plus-circle"></i> &nbsp;
        Create New Online Quote
      </button>
    </div>
  </div>
  <div *ngIf="!isFromManagePolicy" class="row mt-3">
    <div class="col-lg-12 col-md-12">
      <label name="searchPolicies" id="searchPoliciesID" class="label_cls">Search Policies</label>
      <div class="input-group search_policies" *ngIf="!IsBFMInternal">
        <span class="p-input-icon-right">
          <i class="pi pi-search"></i>
          <input autocomplete="off" type="text" class="globalfilter_bar global_search_wid" pInputText
            name="searchPoliciesFilter" id="searchPoliciesFilterID" placeholder="Policy number or Insured's Name"
            [(ngModel)]="PolicyorName" (input)="filterPolicy()" />
        </span>
      </div>
      <div class="input-group internalSearch" *ngIf="IsBFMInternal">
        <span class="p-input-icon-right" style="display: flex;">
            <input autocomplete="off" type="text" class="globalfilter_bar global_search_wid" pInputText name="searchPoliciesFilter"
                id="searchPoliciesFilterID" placeholder="Policy number or Insured's Name"
                [(ngModel)]="PolicyorName" />
            <button name="DocumentBtn" id="DocumentBtnID"
                class="btn-small btn_create_policy_quotes btn_search" (click)="searchForPolicy()">
                <i name="DocumentBtnIcon" id="DocumentBtnIconID" class="fa fa-search"></i> &nbsp;
                Search
            </button>
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="!isFromManagePolicy" class="row">
    <div class="col-lg-12 mt-2">
      <div id="accordion" class="accordion" *ngIf="filteredList.length>0" style="width: 100%;">
        <div class="card mb-0" [id]="'card' + i" *ngFor="let policy of filteredList; let i=index;">
          <a class="card-header">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-lg-2 col-md-2 col-12 policy_Accordian">
                  {{policy?.nameInsured}}
                </div>
                <div class="col-lg-4 col-md-4 col-12 policy_Accordian">
                  {{policy?.jobSiteAddress}}
                </div>
                <div class="col-lg-3 col-md-3 col-12 policy_Accordian">
                  <span class="label_cls">Pol Eff: </span>{{policy?.effectiveDate |
                  date:'MM/dd/yyyy'}} - {{policy?.expireDate | date:'MM/dd/yyyy'}}
                </div>
                <div class="col-lg-3">
                  <button title="Evidence of Insurance" style="float:right"
                    name="OnlineQuoteBtn" id="OnlineQuoteBtnID" class="btn btn-small btn_create_policy_quotes ml-2"
                    (click)="openEvidenceOfInsurance(policy,i)" [disabled]="['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION', 'EXPIRED'].includes(policy.status.toUpperCase())">
                    Evidence of Insurance
                  </button>
                </div>
              </div>
            </div>

            <div style="padding: 5px 12px;">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-lg-2 col-md-3 col-12 policy_num pr-0 policy_Accordian">
                      <span *ngIf="policy?.nameInsured">{{policy?.productName}}</span>
                      <!-- <span *ngIf="policy?.policyNumber">{{policy?.policyNumber}}</span> -->
                    </div>

                    <div class="col-lg-4">
                      <label><span name="billplan" id="billplanID" class="label_cls">Policy#
                          :
                        </span> {{policy?.policyNumber}}</label>
                    </div>
                    <div class="col-lg-3">
                      <label><span name="totalpremium" id="totalpremiumID" class="label_cls">Total Premium: </span> $
                        {{policy?.summaryTotals?.brPremiumAmount}}</label>
                    </div>
                    <div class="col-lg-3 text-center" >
                      <label class="row" style="justify-content: center;">
                        <span name="status" id="statusID" class="label_cls">Status: {{policy?.status}}</span>
                        <div style="margin-left: 5px;" *ngIf="(['CANCELED', 'CANCELLED', 'PENDINGCANCELLATION'].includes(policy?.status.toUpperCase()))"> as of {{policy?.modifyDate | date:"MM/dd/yyyy"}}</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <p-paginator name="paginator" id="paginatorID" class="gen-paginator-override mousePointer"
    *ngIf="!isFromManagePolicy && filteredList.length>0" [rows]="10" [totalRecords]="PolicyQuotesList.length"
    (onPageChange)="paginate($event)"></p-paginator>
  <p-dialog header="" class="dialog_box_new" [(visible)]="isShowEvidence" (onHide)="closeEvidence()" [modal]="true" [baseZIndex]="1000"
    [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <div class="row" style="width:98%">
        <div class="col-lg-6 col-md-6 col-12">
          <!-- <span class="policyHeaderLbl">{{policyChangeModal?.nameInsured}}</span> -->
          <span class="policyHeaderLbl">Evidence of Insurance - {{policyDetails?.clientInfo?.insuredName}}</span>
        </div>
        <div class="col-lg-2 col-md-2 col-12">
          <!-- <span class="policyHeaderLbl mr-2" *ngIf="policyChangeModal?.nameInsured">{{policyChangeModal?.productName}}</span> -->
          <span class="policyHeaderLbl mr-2">{{policyDetails.policyNumber}}</span>
        </div>
        <div class="col-lg-4 col-md-4 col-12">
          <!-- <span class="policyHeaderLbl" *ngIf="policyChangeModal?.policyNumber">{{policyChangeModal?.policyNumber}}</span> -->
          <span class="policyHeaderLbl">Policy Eff: {{policyDetails?.policyStartDate |
            date:'MM/dd/yyyy'}} - {{policyDetails?.policyEndDate | date:'MM/dd/yyyy'}}</span>
        </div>
      </div>
    </ng-template>

    <div class="row eviden mt-2">
      <div class="col-md-6">
        <div class="row">
          <div class="col-lg-1 col-1">
            <i class="fa fa-address-card-o policyIcon"></i>
          </div>
          <div class="col-lg-10">
            <h4>Agency</h4>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-lg-4 col-4 text-right ">
            <span class="policyHeading">Name:</span>
          </div>
          <div class="col-lg-8 col-8">
            <span class="policyLbl">{{policyDetails?.agencyInfo?.name}}</span>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-lg-4 col-4 text-right">
            <span class="policyHeading">Mailing Address:</span>
          </div>
          <div class="col-lg-8 col-8">
            <span class="policyLbl">{{policyDetails?.agencyInfo?.address?.addressNo}} {{policyDetails?.agencyInfo?.address?.addressLine1}}<br /> {{policyDetails?.agencyInfo?.address?.city}}, {{policyDetails?.agencyInfo?.address?.state}} {{policyDetails?.agencyInfo?.address?.zip}}</span>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-lg-4 col-4 text-right">
            <span class="policyHeading">Phone:</span>
          </div>
          <div class="col-lg-8 col-8">
            <div class="row">
              <div class="col-lg-6">
                <span class="policyLbl">{{policyDetails?.agencyInfo?.phone}}</span>
              </div>
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-3 text-right">
                    <span class="policyHeading">Fax:</span>
                  </div>
                  <div class="col-lg-9">
                    <span class="policyLbl">{{policyDetails?.agencyInfo?.fax}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-lg-4 col-4 text-right">
            <span class="policyHeading">Email:</span>
          </div>
          <div class="col-lg-8 col-8">
            <div class="row">
              <div class="col-lg-6">
                <span class="policyLbl">{{policyDetails?.agencyInfo?.email}}</span>
              </div>
              <div class="col-lg-6">
                <div class="row">
                  <div class="col-lg-3 text-right">
                    <span class="policyHeading">Code:</span>
                  </div>
                  <div class="col-lg-8">
                    <div class="row">
                      <div class="col-lg-4">
                        <span class="policyLbl">{{policyDetails?.agencyInfo?.code}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-lg-4 col-4 text-right">
            <span class="policyHeading">Agency CustomerID:</span>
          </div>
          <div class="col-lg-8 col-8">
            <div class="row">
              <div class="col-lg-10 d-flex">
                <input type="text" class="form-control address_controls" id="StreetNO" name="StreetNO" [(ngModel)]="evidenceDetails.AgencyCustomerID"
                placeholder="Agency CustomerID" />
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-lg-1 col-1">
            <i class="fa fa-user policyIcon"></i>
          </div>
          <div class="col-lg-10">
            <h4>Insured</h4>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-lg-4 col-4 text-right ">
            <span class="policyHeading">Name:</span>
          </div>
          <div class="col-lg-8 col-8">
            <span class="policyLbl">{{policyDetails?.clientInfo?.insuredName}}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-4 text-right ">
            <span class="policyHeading">Mailing Address:</span>
          </div>
          <div class="col-lg-8 col-8">
            <span class="policyLbl">{{policyDetails?.clientInfo?.mailingAddress[0].addressNo}} {{policyDetails?.clientInfo?.mailingAddress[0].addressLine1}} <br /> 
              {{policyDetails?.clientInfo?.mailingAddress[0]?.addressLine2}}{{policyDetails?.clientInfo?.mailingAddress[0]?.addressLine2 ? ',' : ''}} {{policyDetails?.clientInfo?.mailingAddress[0].city}}, {{policyDetails?.clientInfo?.mailingAddress[0].state}}, {{policyDetails?.clientInfo?.mailingAddress[0].zip}}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <hr />
          </div>
        </div>

        <div class="row">
          <div class="col-lg-1 col-1">
            <i class="fa fa-handshake-o policyIcon"></i>
          </div>
          <div class="col-lg-10">
            <h4>Policy Information</h4>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-lg-4 col-4 text-right">
            <span class="policyHeading">Company:</span>
          </div>
          <div class="col-lg-8 col-8">
            <div class="row">
              <div class="col-lg-12 d-flex">
                <span class="policyLbl">{{policyDetails?.reportingCompany?.text}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-1">
          <div class="col-lg-4 col-4 text-right">
            <span class="policyHeading">Loan Number:</span>
          </div>
          <div class="col-lg-8 col-8">
            <div class="row">
              <div class="col-lg-6 d-flex">
                <input type="text" class="form-control address_controls" id="loanNo" name="loanNo" [(ngModel)]="evidenceDetails.LoanNumber"
                placeholder="Loan Number" />
              </div>
            </div>
          </div>
        </div>

        <div class="row ">
          <div class="col-lg-4 col-4 text-right">
            <span class="policyHeading">Replace prior evidence dated:</span>
          </div>
          <div class="col-lg-8 col-8">
            <div class="row">
              <div class="col-lg-10 d-flex">
                <input type="text" class="form-control address_controls" id="priorEvidence" name="priorEvidence" [(ngModel)]="evidenceDetails.priorEvidence"
                placeholder="Replace prior evidence dated" />
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="col-md-6">

        <div class="row">
          <div class="col-lg-1 col-1" style="padding: 0;">
            <i class="fa fa-home policyIcon"></i>
          </div>
          <div class="col-lg-10">
            <h4>Property Information</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-4 text-right ">
            <span class="policyHeading">Address:</span>
          </div>
          <div class="col-lg-8 col-8">
            <span class="policyLbl">{{policyDetails?.clientInfo?.jobsiteAddress[0].addressNo}} {{policyDetails?.clientInfo?.jobsiteAddress[0].addressLine1}}, {{policyDetails?.clientInfo?.jobsiteAddress[0].city}}, {{policyDetails?.clientInfo?.jobsiteAddress[0].state}} {{policyDetails?.clientInfo?.jobsiteAddress[0].zip}}</span>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-12 p-0 mb-2">
            <hr />
          </div>
        </div>


        <div class="row">
          <div class="col-lg-1 col-1"  style="padding: 0;">
            <i class="fa fa fa-address-card-o policyIcon"></i>
          </div>
          <div class="col-lg-10">
            <h4>Coverage Information</h4>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-4 text-right ">
            <span class="policyHeading">Deductible: </span>
          </div>
          <div class="col-lg-8 col-8">
            <span class="policyLbl">{{policyDetails?.policyDetails?.deductible}}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-4 text-right ">
            <span class="policyHeading">Jobsite Limit: </span>
          </div>
          <div class="col-lg-8 col-8">
            <span class="policyLbl">{{policyDetails?.policyDetails?.jobsiteLimit}}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 col-4 text-right ">
            <span class="policyHeading">Catastrophe: </span>
          </div>
          <div class="col-lg-8 col-8">
            <span class="policyLbl">{{policyDetails?.policyDetails?.catastropheLimit}}</span>
          </div>
        </div>


        <div class="row">
          <div class="col-lg-12 p-0 " style="margin: 2.28% 0 2%;">
            <hr />
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-lg-2 col-2" style="padding: 0;">
            <span class="policyHeading">Remarks: </span>
          </div>
          <div class="col-lg-10 col-10">
            <div class="row">
              <div class="col-lg-12 d-flex">
                <textarea style="padding: 0px 5px;width: 95%;" placeholder="Remarks" id="remarks" name="remarks" [(ngModel)]="evidenceDetails.remarks" 
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-1 col-1" style="padding: 0;">
            <i class="fa fa-university policyIcon"></i>
          </div>
          <div class="col-lg-5">
            <h4>Interest type</h4>
          </div>

          <!-- <div class="col-lg-5">
            <p-dropdown class="stateDropdown padding_10" required name="state"></p-dropdown>
          </div> -->
          <br>
        </div>
        <div class="row mb-2">
          <div class="offset-lg-1 col-lg-11 col-11">
            <div class="row">
              <b>Select Interest Type: </b>
              <div class="col-lg-12 pl-0 fintype" style="margin-top: 10px;">
                <div *ngFor="let interestType of financialInterestData; let i=index" class="p-field-checkbox" style="margin-left: 20px;">
                  <span class="radioBtnHeader">{{interestType?.interestType}}</span>
                  <div class="p-field-radiobutton row">
                    <span title="clear" style="cursor: pointer;" *ngIf="interestType.TempinterestID == evidenceDetails.interestType && evidenceDetails.interestType != null" (click)="evidenceDetails.interestType = null" class="interestClrcls fa fa-close"></span>
                    <p-radioButton *ngIf="interestType.TempinterestID != evidenceDetails.interestType" name="interestType" name="interestType_{{i}}" (onClick)="isShowError = false;" [value]="interestType.TempinterestID" [(ngModel)]="evidenceDetails.interestType" inputId="interestType_{{i}}"></p-radioButton>
                    <label class="policyLbl {{interestType.TempinterestID == evidenceDetails.interestType && evidenceDetails.interestType != null ? 'selectedinterest' : ''}}" style="margin-left: 10px;pointer-events: none;" for="interestType_{{i}}">{{interestType?.businessName}}<br>
                      {{interestType?.addressInfo[0]?.addressNo}} {{interestType?.addressInfo[0]?.addressLine1}}, {{interestType?.addressInfo[0]?.addressLine2}} {{interestType?.addressInfo[0]?.city}}, {{interestType?.addressInfo[0]?.state}} {{interestType?.addressInfo[0]?.zip}}</label>
                </div>
              </div>
              </div>
            </div>
            <!-- <div *ngIf="isShowError">
              <span style="color: red;">{{errorMsg}}</span>
            </div> -->
          </div>
        </div>
        <div class="row float-right">
          <div class="col-lg-12 mb-2">
            <!-- <a href="#" class="mr-3">Click to add financial Interest</a> -->
            <button class="policyCloseBtn" title="Request Evidence of Insurance" style="padding: 0px 20px;" (click)="submitEvidence();" type="button">Request Evidence of Insurance</button>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
  <!-- <p-confirmDialog *ngIf="!isFromManagePolicy" [style]="{width: '50vw'}" styleClass="confirmbtn" [baseZIndex]="1000" rejectButtonStyleClass="p-button-text"></p-confirmDialog> -->
</div>